import { gql } from "@apollo/client";

export default gql`
  mutation uploadAnnouncementMedia($input: UploadChangelogMediaInput!){
    uploadAnnouncementMedia(input: $input){
        success
        data{
            url
            type
        }
        error
        message
    }
}
`
